import React, { useState } from 'react'
import { Row, Col } from 'antd';
import styled from 'styled-components'

import { FaNode,
         FaGithub,
         FaHtml5,
         FaLess,
         FaJsSquare,
         FaNpm,
         FaYarn,
         FaReact,
         FaVuejs,
         FaAngular,
         FaCss3,
         FaBootstrap,
         FaFigma,
         FaGitlab,
         FaWordpressSimple,
         FaChartBar,
         FaPython,
         FaUbuntu,
         FaWindows
        } from 'react-icons/fa';
import { DiVisualstudio } from 'react-icons/di'
import {AiOutlineAntDesign} from 'react-icons/ai'
import StackAbout from './StackAbout';

export default function Stack() {

    const [tech, setTech] = useState('html')

    const techs = [
        {
            icon: <FaNode style={{cursor: 'pointer'}} color='#545456' title='NodeJs' size='3rem' />,
            path: 'node',
        },
        {
            icon: <FaGithub style={{cursor: 'pointer'}} color='#545456' title='Github' size='3rem' />,
            path: 'github'
        },
        {
            icon: <FaHtml5 style={{cursor: 'pointer'}} color='#545456' title='HTML' size='3rem' />,
            path: 'html'
        },
        {
            icon: <FaLess style={{cursor: 'pointer'}} color='#545456' title='LESS' size='3rem' />,
            path: 'less'
        },
        {
            icon: <FaCss3 style={{cursor: 'pointer'}} color='#545456' title='CSS' size='3rem' />,
            path: 'css'
        },
        {
            icon: <FaJsSquare style={{cursor: 'pointer'}} color='#545456' title='JavaScript' size='3rem' />,
            path: 'js'
        },
        {
            icon: <FaNpm style={{cursor: 'pointer'}} color='#545456' title='NPM' size='3rem' />,
            path: 'npm'
        },
        {
            icon: <FaYarn style={{cursor: 'pointer'}} color='#545456' title='Yarn' size='3rem' />,
            path: 'yarn'
        },
        {
            icon: <FaReact style={{cursor: 'pointer', animation: 'spin 5s linear infinite'}} color='#545456' title='ReactJs' size='3rem' />,
            path: 'react'
        },
        {
            icon: <FaVuejs style={{cursor: 'pointer'}} color='#545456' title='VueJs' size='3rem' />,
            path: 'vue'
        },
        {
            icon: <FaAngular style={{cursor: 'pointer'}} color='#545456' title='Angular2+' size='3rem' />,
            path: 'angular'
        },
        {
            icon: <FaReact style={{cursor: 'pointer', animation: 'spin 5s linear infinite'}} color='#545456' title='ReactNative' size='3rem' />,
            path: 'react-native'
        },
        {
            icon: <FaBootstrap style={{cursor: 'pointer'}} color='#545456' title='Bootstrap' size='3rem' />,
            path: 'bootstrap'
        },
        {
            icon: <FaFigma style={{cursor: 'pointer'}} color='#545456' title='Figma' size='3rem' />,
            path: 'figma'
        },
        {
            icon: <FaGitlab style={{cursor: 'pointer'}} color='#545456' title='Figma' size='3rem' />,
            path: 'gitlab'
        },
        {
            icon: <FaWordpressSimple style={{cursor: 'pointer'}} color='#545456' title='Wordpress' size='3rem' />,
            path: 'wordpress'
        },
        {
            icon: <FaChartBar style={{cursor: 'pointer'}} color='#545456' title='ApexChart' size='3rem' />,
            path: 'apexchart'
        },
        {
            icon: <DiVisualstudio style={{cursor: 'pointer'}} color='#545456' title='VisualCode' size='3rem' />,
            path: 'vscode'
        },
        {
            icon: <FaPython style={{cursor: 'pointer'}} color='#545456' title='Python' size='3rem' />,
            path: 'python'
        },
        {
            icon: <AiOutlineAntDesign style={{cursor: 'pointer'}} color='#545456' title='Antd Design' size='3rem' />,
            path: 'antd'
        },
        {
            icon: <FaUbuntu style={{cursor: 'pointer'}} color='#545456' title='Ubuntu' size='3rem' />,
            path: 'ubuntu'
        },
        {
            icon: <FaWindows style={{cursor: 'pointer'}} color='#545456' title='Windows' size='3rem' />,
            path: 'windows'
        }
    ]

    return (
        <>
            <Row align='center' justify='center' style={{padding: '60px 0', width: '100%'}}>
                <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                    <StackAbout tech={tech} />
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                    <Div>
                        {techs.map(item=>{
                            return (
                                <StackTech key={item.path} onClick={()=>{setTech(item.path)}}>
                                    {item.icon}
                                </StackTech>
                            )
                        })}
                    </Div>
                </Col>
            </Row>
        </>
    )
}

const Div = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    height: 100%
`

const StackTech = styled.div`
    width: 25%;
    text-align: center;
    padding: 10px 0;
`